'use client';
import { useAuthenticated, usePrivyUser, useReady } from '@/store';
import { getAccessToken } from '@privy-io/react-auth';
import { useCallback, useEffect, useMemo } from 'react';
import { backendURL, backendURL_V3, local } from './constants';
interface AuthTokenInterface {
	v?: 3;
}
const useBackend = () => {
	const privyUser = usePrivyUser();

	const getToken = useCallback(
		async ({ v }: AuthTokenInterface) => {
			const token = await getAccessToken();

			if (!token) {
				return null;
			}

			return v === 3 ? `Bearer ${token}` : `AccessToken=${token}`;
		},
		[privyUser]
	);

	useEffect(() => {
		getAccessToken();
	}, []);
	// const backend = Object.freeze({
	// 	url: backendURL || local,
	// 	url_V3: backendURL_V3 || local,
	// 	getAccessToken: getToken,
	// });
	const backend = useMemo(() => {
		return {
			url: backendURL || local,
			url_V3: backendURL_V3 || local,
			getAccessToken: getToken,
		};
	}, [privyUser]);
	return { ...backend };
};
export default useBackend;
